<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 시설물 안전 계획 -->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 시설물 안전 계획</h5>
      </vs-col>
      <div class="w-full grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text">시설물별 안전계획</div>
          <p v-if="isPrint" class="print-input">
            {{ form.inputA_1.fileName }}
          </p>
          <file-uploader :readonly="board.readonly" v-else v-model="form.inputA_1" class="w-full flex-1" />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text">예산</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <comma-input v-else :readonly="board.readonly" v-model="form.inputA_2" class="w-full flex-1" />
        </div>
      </div>
    </vs-row>

    <!-- 정기안전점검 계획 일자 -->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 정기안전점검 계획 일자</h5>
      </vs-col>
      <div class="w-full grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text">상반기</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputB_1" class="w-full flex-1" />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text">하반기</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputB_2" class="w-full flex-1" />
        </div>
      </div>
    </vs-row>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploader from "@/components/FileUploader.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        inputA_1: {},
        inputA_2: "",
        inputB_1: "",
        inputB_2: "",
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  min-width: 114px;
  font-weight: 500;
  font-size: 14px;
  margin-right: 20px;
}
</style>
